import * as redux from 'redux';
import { TOKEN_KEY, GUEST_CART_KEY } from './session';

const GUEST_COUNT_KEY = 'natureway_guest_cart_count';
const readGuestCount = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(GUEST_COUNT_KEY));
        return !localStorage.getItem(TOKEN_KEY) && saved
            && saved.guestCartId === localStorage.getItem(GUEST_CART_KEY)
            && Number.isInteger(saved.count) && saved.count >= 0 ? saved.count : 0;
    } catch {
        return 0;
    }
};
// import { message, Button } from 'antd';

//Actions
export const CART_COUNT_UPDATE = "cartcount";
export const COMPARE_COUNT_UPDATE = "comparecount";

const initialState={
    count:0,
}

const cartReducer = (state = { count: readGuestCount() }, action) =>{
    // console.log(action);
    switch(action.type){
        case CART_COUNT_UPDATE:{
            return {...state, count:action.value};
            break;
        }
        default:{
            return state;
        }
    }
}

const compareReducer = (state = initialState, action) =>{
    // console.log(action);
    switch(action.type){
        case COMPARE_COUNT_UPDATE:{
            return {...state, count:action.value};
            break;
        }
        default:{
            return state;
        }
    }
}

const rootReducer  = (state = initialState, action) =>{
    return{
        cart: cartReducer(state.cart, action),
        compare: compareReducer(state.compare, action),
    }
}

const store=redux.createStore(rootReducer);
store.subscribe(() => {
    try {
        const guestCartId = localStorage.getItem(GUEST_CART_KEY);
        if (!localStorage.getItem(TOKEN_KEY) && guestCartId) {
            localStorage.setItem(GUEST_COUNT_KEY, JSON.stringify({ guestCartId, count: store.getState().cart.count }));
        } else {
            localStorage.removeItem(GUEST_COUNT_KEY);
        }
    } catch {
        // Cart requests still work when browser storage is unavailable.
    }
});
export default store;